import 'lazysizes';

import { ImageAutoOptimizer } from './image-auto-optimizer';

/* Docs: "In case you are using a module bundler it is recommended to change the options directly after importing the lazysizes module" */
lazySizes.cfg.init = false;

/* lazysizes API events */
document.addEventListener('lazybeforeunveil', function(e) {
    const $target = $(e.target);
    ImageAutoOptimizer.buildUrl($target);

    const bg = $target.attr('data-bg');
    if (bg) {
        $target.css('background-image', 'url(' + bg + ')');
    }
});
document.addEventListener('lazyloaded', function(e) {
    const $target = $(e.target);

    if ($target.hasClass('js-link-wrapper-target')) {
        const $ciLinkWrapper = $target.closest('.' + $target.data('parent-class')).find('.js-link-wrapper-lazyload');
        if ($ciLinkWrapper.length) {
            import(ICUBE_LINK_WRAPPER).then(() => $ciLinkWrapper.ciLinkWrapper())
        }
    }
});
/* END lazysizes API events */

export const Lazyloader = {
    /* globalna inicjacja lazyloada obrazów */
    init: () => {
        lazySizes.init();
    },
    /* lazyload pojedynczego obrazu */
    load: ($image) => {
        lazySizes.loader.unveil($image.get(0));
    },
    addClassesOnImagesTags: () => {
        const $images = document.getElementsByTagName('img');

        for (let i = 0, len = $images.length; i < len; i++) {
            const $img = $images[i];

            if (!$img.classList.contains('lazyload') && $img.dataset.src) {
                $img.classList.add('lazyload');
            }
        }
    }
}